import { useState } from "react";
import { Mail, Loader2, Check } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterSignup() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setBusy(true);
        try {
            await api.post("/newsletter/subscribe", { email });
            setDone(true);
            toast.success("Subscrição confirmada!");
            setTimeout(() => { setDone(false); setEmail(""); }, 5000);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Erro a subscrever");
        } finally {
            setBusy(false);
        }
    };

    return (
        <section className="container-edge py-16" data-testid="newsletter-section">
            <div className="border-2 border-ink bg-paper grid lg:grid-cols-[1fr_440px] overflow-hidden">
                <div className="p-10 lg:p-14">
                    <div className="label-mono text-magenta">Novidades</div>
                    <h2 className="font-display font-light text-3xl md:text-4xl tracking-tight mt-2 leading-tight">
                        Receba <span className="text-magenta font-medium">primeiro</span> as<br className="hidden md:block"/>
                        promoções e novidades.
                    </h2>
                    <p className="mt-4 text-ink/70 max-w-md">
                        Cupões exclusivos, equipamentos novos em stock e dicas técnicas para a
                        sua impressora — directamente no seu email.
                    </p>
                    <ul className="mt-5 space-y-1.5 text-sm font-mono text-ink/60">
                        <li className="flex items-center gap-2">✓ Cupões só para subscritores</li>
                        <li className="flex items-center gap-2">✓ Sem spam — 1-2 emails/mês</li>
                        <li className="flex items-center gap-2">✓ Pode anular quando quiser</li>
                    </ul>
                </div>
                <div className="bg-ink p-10 lg:p-14 flex flex-col justify-center">
                    {done ? (
                        <div className="text-center" data-testid="newsletter-success">
                            <div className="inline-flex items-center justify-center w-14 h-14 border-2 border-magenta bg-magenta mb-4">
                                <Check size={26} className="text-white" />
                            </div>
                            <div className="text-white font-display font-light text-2xl mb-2">Está dentro.</div>
                            <p className="text-white/60 text-sm font-mono">Verifique o seu email — enviámos uma mensagem de boas-vindas.</p>
                        </div>
                    ) : (
                        <form onSubmit={submit}>
                            <div className="text-white font-mono text-xs uppercase tracking-wider mb-3 flex items-center gap-2">
                                <Mail size={14} /> O seu email
                            </div>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="o-seu@email.com"
                                required
                                className="w-full bg-transparent border-b-2 border-white/30 focus:border-magenta py-3 text-white text-lg outline-none transition-colors placeholder-white/30"
                                data-testid="newsletter-email-input"
                            />
                            <button
                                type="submit"
                                disabled={busy || !email}
                                className="mt-6 w-full bg-magenta text-white py-3 px-6 font-bold uppercase tracking-wider text-sm hover:bg-white hover:text-ink transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                                data-testid="newsletter-submit-btn"
                            >
                                {busy && <Loader2 className="animate-spin" size={16} />}
                                {busy ? "A subscrever…" : "Subscrever Newsletter"}
                            </button>
                            <p className="mt-3 text-xs text-white/40 font-mono">
                                Ao subscrever, aceita a nossa{" "}
                                <a href="/legal/privacidade" className="underline hover:text-white">política de privacidade</a>.
                            </p>
                        </form>
                    )}
                </div>
            </div>
        </section>
    );
}
